// src/services/discountService.js
import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

const discountService = {
  getAll: (params = {}) => apiClient.get(ENDPOINTS.DISCOUNT.GET_ALL, { params }),
  getById: (id) => apiClient.get(ENDPOINTS.DISCOUNT.GET_BY_ID(id)),
  getByCode: (code) => apiClient.get(ENDPOINTS.DISCOUNT.GET_BY_CODE(code)),
  create: (payload) => apiClient.post(ENDPOINTS.DISCOUNT.CREATE, payload),
  update: (id, payload) => apiClient.put(ENDPOINTS.DISCOUNT.UPDATE(id), payload),
  remove: (id) => apiClient.delete(ENDPOINTS.DISCOUNT.DELETE(id)),
  deactivate: (id) => apiClient.put(ENDPOINTS.DISCOUNT.DEACTIVATE(id)),
};

export default discountService;
